<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    @open="handleOpen"
    @close="handleClose"
    destroy-on-close
  >
    <el-form
      label-width="120px"
      :rules="rules"
      :model="editForm"
      ref="editForm"
    >
      <el-form-item label="部门名称" prop="deptName">
        <el-input
          size="small"
          v-model="editForm.deptName"
          auto-complete="off"
          placeholder="部门名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="上级部门" prop="parentName">
        <el-input
          size="small"
          v-model="editForm.parentName"
          auto-complete="off"
          placeholder="上级部门"
          readonly
        >
          <el-button slot="append" type="primary" @click="handleParent"
            >请选择</el-button
          ></el-input
        >
      </el-form-item>
      <el-form-item label="排序" prop="orderNum">
        <el-input
          size="small"
          v-model="editForm.orderNum"
          auto-complete="off"
          placeholder="排序"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="roleId">
        <el-select size="small" v-model="editForm.roleId" placeholder="请选择">
          <el-option
            v-for="item of roleCols"
            :key="item.id"
            :label="item.roleName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" type="primary" @click="handleSubmit"
        >确定</el-button
      >
      <el-button size="small" @click="handleClose">返回</el-button>
    </div>
    <Dept :visible.sync="visibleDept" @confirm="handleConfirm"></Dept>
  </el-dialog>
</template>

<script>
import { selectRole } from "@/api/system/role";
import { saveOrUpdateDept } from "@/api/system/dept";
import Dept from "@/views/components/dept";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    Dept,
  },
  data() {
    return {
      roleCols: [],
      rules: {
        deptName: [
          { required: true, message: "请输入部门名", trigger: "blur" },
        ],
        parentName: [
          { required: true, message: "请选择上级部门", trigger: "blur" },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "blur" }],
      },
      visibleDept: false,
    };
  },
  methods: {
    getRole() {
      selectRole().then((data) => {
        this.roleCols = data;
      });
    },
    handleParent() {
      this.visibleDept = true;
    },
    handleConfirm(data) {
      this.editForm.parentId = data.id;
      this.editForm.parentName = data.deptName;
      this.$emit("update:editForm", this.editForm);
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const formData = Object.entries(this.editForm).reduce(
            (prev, [key, value]) => {
              if (key === "roleId") {
                prev["role"] = {
                  id: value,
                };
              } else {
                prev[key] = value;
              }
              return prev;
            },
            {}
          );
          saveOrUpdateDept(formData)
            .then(() => {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });
        }
      });
    },
    handleOpen() {
      this.getRole();
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>







// WEBPACK FOOTER //
// src/views/system/department/add-edit/index.vue